/* eslint class-methods-use-this: 0 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash';
import { priceCartComputer } from './price-cart-calculations';
import { serverSideComputations } from './legacy-calculations';
import { CALCULATION_PRICE_SERVICE } from 'shared/constants';
var OrderComputationsAsync = /*#__PURE__*/ function() {
    "use strict";
    function OrderComputationsAsync() {
        _class_call_check(this, OrderComputationsAsync);
    }
    _create_class(OrderComputationsAsync, null, [
        {
            key: "compute",
            value: function compute(param) {
                var data = param.data, logger = param.logger, _param_apolloClient = param.apolloClient, apolloClient = _param_apolloClient === void 0 ? null : _param_apolloClient, _param_restApi = param.restApi, restApi = _param_restApi === void 0 ? null : _param_restApi, _param_ddMetric = param.ddMetric, ddMetric = _param_ddMetric === void 0 ? null : _param_ddMetric;
                return _async_to_generator(function() {
                    var _data_discountSyncEnabled, priceCartEnabled, priceService, calcOptions, response;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                priceCartEnabled = (_data_discountSyncEnabled = data.discountSyncEnabled) !== null && _data_discountSyncEnabled !== void 0 ? _data_discountSyncEnabled : false;
                                priceService = data.priceService; // "ecomm-checkout", "plus-checkout", or "cart
                                calcOptions = {
                                    logger: logger,
                                    apolloClient: apolloClient,
                                    restApi: restApi,
                                    ddMetric: ddMetric,
                                    priceService: priceService
                                };
                                if (!priceCartEnabled) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    priceCartWrapper(data, calcOptions)
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    legacyWrapper(data, calcOptions)
                                ];
                            case 3:
                                response = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OrderComputationsAsync;
}();
export { OrderComputationsAsync as default };
function legacyWrapper(data, _) {
    return _legacyWrapper.apply(this, arguments);
}
function _legacyWrapper() {
    _legacyWrapper = _async_to_generator(function(data, param) {
        var logger, apolloClient, priceService, error, _data_dispensary;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    logger = param.logger, apolloClient = param.apolloClient, priceService = param.priceService;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        serverSideComputations(data, logger, apolloClient, priceService)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    logger.error("Error in legacyWrapper | ".concat(priceService), {
                        error: error.message,
                        dispensaryId: (_data_dispensary = data.dispensary) === null || _data_dispensary === void 0 ? void 0 : _data_dispensary.id
                    });
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _legacyWrapper.apply(this, arguments);
}
function priceCartWrapper(data, _) {
    return _priceCartWrapper.apply(this, arguments);
}
function _priceCartWrapper() {
    _priceCartWrapper = _async_to_generator(function(data, param) {
        var logger, apolloClient, restApi, ddMetric, priceService, priceCartResponse, legacyComputerResponse, errors, returnLegacy, legacyError, error, legacyError1, _window, shouldLog;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    logger = param.logger, apolloClient = param.apolloClient, restApi = param.restApi, ddMetric = param.ddMetric, priceService = param.priceService;
                    priceCartResponse = {};
                    legacyComputerResponse = {};
                    errors = [];
                    returnLegacy = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        12,
                        13
                    ]);
                    return [
                        4,
                        priceCartComputer(data, logger, apolloClient, restApi, priceService)
                    ];
                case 2:
                    priceCartResponse = _state.sent();
                    if (!priceCartResponse.shouldFallback) return [
                        3,
                        6
                    ];
                    returnLegacy = true;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        legacyWrapper(data, {
                            logger: logger,
                            apolloClient: apolloClient,
                            priceService: priceService
                        })
                    ];
                case 4:
                    legacyComputerResponse = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    legacyError = _state.sent();
                    errors.push(legacyError);
                    legacyComputerResponse = {};
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    error = _state.sent();
                    errors.push(error);
                    priceCartResponse = {
                        error: error
                    };
                    returnLegacy = true;
                    _state.label = 8;
                case 8:
                    _state.trys.push([
                        8,
                        10,
                        ,
                        11
                    ]);
                    return [
                        4,
                        legacyWrapper(data, {
                            logger: logger,
                            apolloClient: apolloClient,
                            priceService: priceService
                        })
                    ];
                case 9:
                    legacyComputerResponse = _state.sent();
                    return [
                        3,
                        11
                    ];
                case 10:
                    legacyError1 = _state.sent();
                    errors.push(legacyError1);
                    legacyComputerResponse = {};
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window._____APP_STATE_____)) {
                        // the legacy response gets added in computations_calcs.js, as "debugging.calculations"
                        _.set(window._____APP_STATE_____, 'debugging.priceCartCalculations', priceCartResponse);
                    }
                    // we want to log if the cart is not empty, or if there are errors, or if the price cart timed out
                    shouldLog = cartIsNotEmpty(priceCartResponse) || cartIsNotEmpty(legacyComputerResponse) || errors.length > 0 || priceCartResponse.timedOut;
                    if (shouldLog) {
                        afterCalculations({
                            logger: logger,
                            ddMetric: ddMetric,
                            priceService: priceService,
                            errors: errors,
                            timedOut: priceCartResponse.timedOut
                        });
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        2,
                        returnLegacy ? legacyComputerResponse : priceCartResponse
                    ];
            }
        });
    });
    return _priceCartWrapper.apply(this, arguments);
}
function afterCalculations(param) {
    var logger = param.logger, ddMetric = param.ddMetric, priceService = param.priceService, errors = param.errors, timedOut = param.timedOut;
    var metricName = "dutchie.ecomm.price-cart-calculations";
    var shouldLogMetric = priceService !== CALCULATION_PRICE_SERVICE.cart;
    if (timedOut) {
        if (shouldLogMetric) {
            ddMetric().increment(metricName.concat('.timeout'), {
                env: process.env.APP_ENV,
                priceService: priceService
            });
        }
        return;
    }
    if (_.size(errors) > 0) {
        _.forEach(errors, function(error) {
            logger.error("Errors in async calculations | ".concat(priceService), error);
        });
        if (shouldLogMetric) {
            ddMetric().increment(metricName.concat('.error'), {
                env: process.env.APP_ENV,
                priceService: priceService
            });
        }
    }
}
function cartIsNotEmpty(response) {
    var _response_receipt;
    return _.some(response === null || response === void 0 ? void 0 : (_response_receipt = response.receipt) === null || _response_receipt === void 0 ? void 0 : _response_receipt.summary, function(value) {
        return value !== 0;
    });
}
